// extracted by css-extract-rspack-plugin
export default {"yellow":"yellow-1qJ9hT","root":"root-DHgvmR","lead":"lead-eXnbyL","pic":"pic-RAJa5j"};